export default __webpack_public_path__ + "static/media/juego5_ganar.bd0065b8.png";